<nav class="head-nav">
    <div class="nav-container">
        <div>
            <h2>{{ "availabilty.Hours" | translate }}</h2>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
                </li>
                <li class="breadcrumb-item" *ngIf="restaurantId">
                    <a class="breadcrumb-restaurant-name" [routerLink]='["/admin/restaurants/profile", restaurantId]'>{{restaurantData?.name}}</a>
                </li>
                <li class="breadcrumb-item">{{"publish.Availability" | translate}}</li>
                <li class="breadcrumb-item">{{ "availabilty.Hours" | translate }}</li>
            </ol>
        </div>
        <app-restaurants-dropdown (all)="restaurantId = $event; GetScreenData()"></app-restaurants-dropdown>
    </div>
</nav>

<div class="form-page">
    <div class="form-content">
        
        <div class="row top-buttons mt-5 mb-3" *ngIf="recordsData?.canEdit">
            <div class="col-md-6">
                <button mat-button class="cancel" 
                (click)="openConfirmDialog()"
                [disabled]="btnLoading">{{'forms.Cancel' |
                  translate}}</button>
              </div>
            <div class="col-md-6 ml-auto">
                <button mat-button class="continue" 
                (click)="saveRecord()"
                [disabled]="btnLoading"
                [class.loading]="btnLoading">{{'forms.Save' |
                    translate}}</button>
            </div>
        </div>
        <br>
        <div *ngIf='dataLoading' class="dataLoading">
            <mat-spinner class="m-auto" diameter="50"></mat-spinner>
        </div>
        <ng-container *ngIf='!dataLoading'>
            <div class="card mt-3">
                <div class="card-head">
                    <div class="title">{{'availabilty.Set Time Slots for Reservations (Walk-in and Online)' | translate}}
                    </div>
                </div>
                <div class="card-content">
                    <p class="info mt-3 mb-4">
                        {{'availabilty.The hours you set here will be reflected on the open hours shown on the restaurants profile.' | translate}}
                    </p>
                    <div class="table-responsive mt-3 full-table-background">
                        <table class="table-list">
                            <thead>
                                <th style="width: 20%;">{{"general.Activate" | translate}}</th>
                                <th class="text-left">{{"availabilty.Day" | translate}}</th>
                                <th class="text-left">{{"availabilty.Open Hours" | translate}}</th>
                                <th class="text-right">{{"availabilty.Slots" | translate}}</th>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of recordsData?.workingDays">
                                    <td>
                                        <div>
                                            <mat-slide-toggle [(ngModel)]="item.isActive"
                                                [ngModelOptions]="{standalone: true}" (toggleChange)="changeToggle(item.name, item.isActive, item, item.selectedHours)"></mat-slide-toggle>
                                        </div>
                                    </td>
                                    <td>
                                        <p class="font-16 fontMedium">{{item.name}}</p>
                                    </td>
                                    <td>
                                        <div class="row clocks">
                                            <div class="form-to-time d-flex">
                                                <span class="font-16 fontRegular"
                                                    *ngIf="item.selectedHours">{{item.selectedHours[0]?.timefrom}}</span>
                                                <img src="./assets/images/icons/Path 19134.svg" class="ml-auto mr-3"
                                                    width="15%">
                                            </div>
                                            <p class="ml-2 mr-2 font-16 fontMedium">{{'content2.to' | translate}}</p>
                                            <div class="form-to-time d-flex">
                                                <span class="font-16 fontRegular"
                                                    *ngIf="item.selectedHours">{{item.selectedHours[item.selectedHours.length
                                                    - 1]?.timefrom}}</span>
                                                <img src="./assets/images/icons/Path 19134.svg" class="ml-auto mr-3"
                                                    width="15%">
                                            </div>
                                        </div>
                                    </td>
                                    <td class="actions">
                                        <div class="card-actions">
                                            <button mat-icon-button (click)="openHourConfigForm(item, item.selectedHours)"
                                                *ngIf="recordsData?.canEdit">
                                                <img src="./assets/images/icons/settings_black_24dp.svg">
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
